import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';

import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import styles from './styles.module.css';
import { useCanStartImport } from '../../../../hooks/use-can-start-import';
import { useImportContext } from '../../../import-context';
import { useStepDetectiveContext } from '../../../step-detective/step-detective-context';

/**
 * Basic component for generating footer for create mapping step.
 * Don't add functions to it here unless every type of import will support it.
 * Instead, create your own component and assign it to the renderFooter in your step.
 * @returns {React.JSX.Element}
 */
export const CreateMappingStepFooter = () => {
  const { onImport, isImportLoading, validateUserMapping, isMappingResultValid } = useImportContext();

  const { goToPrevious, goToNext } = useStepDetectiveContext();

  const onImportClick = () => {
    const isValid = validateUserMapping();
    if (!isValid || !isMappingResultValid) {
      return;
    }
    onImport(goToNext);
  };

  const isStartImportBtnDisabled = useCanStartImport();

  return (
    <>
      <Button className={styles['back-btn']} disabled={isImportLoading} onClick={goToPrevious} theme={THEME_CONSTANTS.link}>
        <FontAwesomeIcon className={styles.icon} icon={faArrowLeft} />
        <FormattedMessage {...messages.backBtn} />
      </Button>
      <Button
        className={styles['continue-btn']}
        disabled={isStartImportBtnDisabled}
        onClick={onImportClick}
        theme={THEME_CONSTANTS.primary}
      >
        <FormattedMessage {...messages.startImportBtn} />
      </Button>
    </>
  );
};
